import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import TimelineIcon from '@mui/icons-material/Timeline';
import { Card, Typography } from '@totalsoft/rocket-ui';
import ThinDivider from 'components/common/ThinDivider';

export const OfferKPIComponent = ({ t, offerKpi, isIconCard }) =>
  isIconCard ? (
    <Card icon={TimelineIcon} title={t('Offer.KPI.Title')}>
      <Grid container spacing={1} alignItems='center'>
        <Grid item xs={12} md={6}>
          {t('Offer.KPI.OfferDate')}
        </Grid>
        <Grid item xs={12} md={6} textAlign='right'>
          <span>{t('LONG_DATE', { date: offerKpi.leasingOfferDate })}</span>
        </Grid>

        <Grid item xs={12} md={6}>
          {t('Offer.KPI.OfferTimespan')}
        </Grid>
        <Grid item xs={12} md={6} textAlign='right'>
          <Typography variant='button' color='error'>
            {t('NUMBER', { number: Math.floor(offerKpi.timeFromCreation / 60) })} {t('Hours')} {' , '}{' '}
            {t('NUMBER', { number: offerKpi.timeFromCreation % 60 })} {t('Minutes')}
          </Typography>
        </Grid>

        <Grid item xs={12} md={6}>
          {t('Offer.KPI.OfferUserTime')}
        </Grid>
        <Grid item xs={12} md={6} textAlign='right'>
          <Typography variant='button' color='error'>
            {t('NUMBER', { number: Math.floor(offerKpi.timeOnTask / 60) })} {t('Hours')} {' , '}{' '}
            {t('NUMBER', { number: offerKpi.timeOnTask % 60 })} {t('Minutes')}
          </Typography>
        </Grid>

        <Grid item xs={12} md={6}>
          {t('Offer.KPI.OfferGenerationDate')}
        </Grid>
        <Grid item xs={12} md={6} textAlign='right'>
          <span>{t('DATE', { date: offerKpi.leasingOfferApplicationGenerationDate })}</span>
        </Grid>

        <Grid item xs={12} md={6}>
          {t('Offer.KPI.OfferTimeToYes')}
        </Grid>
        <Grid item xs={12} md={6} textAlign='right'>
          <Typography variant='button' color='error'>
            {t('NUMBER', { number: Math.floor(offerKpi.timeToYes / 60) })} {t('Hours')} {' , '}{' '}
            {t('NUMBER', { number: offerKpi.timeToYes % 60 })} {t('Minutes')}
          </Typography>
        </Grid>
      </Grid>
    </Card>
  ) : (
    <Grid container spacing={1} alignItems='center' px={3} py={2}>
      <Grid item xs={12}>
        <Typography variant='subtitle1' fontWeight='bold' color='primary'>
          {t('Offer.KPI.Title')}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <ThinDivider />
      </Grid>
      <Grid item xs={12} md={6}>
        {t('Offer.KPI.OfferDate')}
      </Grid>
      <Grid item xs={12} md={6} textAlign='right'>
        <span>{t('LONG_DATE', { date: offerKpi.leasingOfferDate })}</span>
      </Grid>

      <Grid item xs={12} md={6}>
        {t('Offer.KPI.OfferTimespan')}
      </Grid>
      <Grid item xs={12} md={6} textAlign='right'>
        <Typography variant='button' color='error'>
          {t('NUMBER', { number: Math.floor(offerKpi.timeFromCreation / 60) })} {t('Hours')} {' , '}{' '}
          {t('NUMBER', { number: offerKpi.timeFromCreation % 60 })} {t('Minutes')}
        </Typography>
      </Grid>

      <Grid item xs={12} md={6}>
        {t('Offer.KPI.OfferUserTime')}
      </Grid>
      <Grid item xs={12} md={6} textAlign='right'>
        <Typography variant='button' color='error'>
          {t('NUMBER', { number: Math.floor(offerKpi.timeOnTask / 60) })} {t('Hours')} {' , '}{' '}
          {t('NUMBER', { number: offerKpi.timeOnTask % 60 })} {t('Minutes')}
        </Typography>
      </Grid>

      <Grid item xs={12} md={6}>
        {t('Offer.KPI.OfferGenerationDate')}
      </Grid>
      <Grid item xs={12} md={6} textAlign='right'>
        <span>{t('DATE', { date: offerKpi.leasingOfferApplicationGenerationDate })}</span>
      </Grid>

      <Grid item xs={12} md={6}>
        {t('Offer.KPI.OfferTimeToYes')}
      </Grid>
      <Grid item xs={12} md={6} textAlign='right'>
        <Typography variant='button' color='error'>
          {t('NUMBER', { number: Math.floor(offerKpi.timeToYes / 60) })} {t('Hours')} {' , '}{' '}
          {t('NUMBER', { number: offerKpi.timeToYes % 60 })} {t('Minutes')}
        </Typography>
      </Grid>
    </Grid>
  );

OfferKPIComponent.propTypes = {
  offerKpi: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  isIconCard: PropTypes.bool.isRequired
};

export default compose(withTranslation())(memo(OfferKPIComponent));
